import React from 'react';
import AnimalSelector from '../AnimalSelector';
import EggColorSelector from '../EggColorSelector';

function AuthOverlays({
  showLogin,
  showSyncNotification,
  showAnimalSelection,
  showEggSelector,
  selectedAnimal,
  authUser,
  onGoogleLogin,
  onMergeConfirm,
  onDismissSync,
  onSelectAnimal,
  onConfirmBuddy,
  onBackToAnimalSelection,
}) {
  return (
    <>
      {showLogin && (
        <div className="login-overlay">
          <div className="login-modal">
            <h2>Welcome back</h2>
            <p>Sign in to sync your journey across devices.</p>
            <button className="google-login" onClick={onGoogleLogin}>
              Continue with Google
            </button>
            <div className="login-links">
              <a href="/privacy.html" target="_blank" rel="noreferrer">Privacy Policy</a>
              <a href="/terms.html" target="_blank" rel="noreferrer">Terms of Service</a>
            </div>
          </div>
        </div>
      )}

      {showSyncNotification && (
        <div className="sync-notification-overlay">
          <div className="sync-notification-modal">
            <h2>⚠️ Data Out of Sync</h2>
            <p>Your local data differs from cloud data. Would you like to sync your local progress to the cloud?</p>
            <div className="sync-actions">
              <button className="sync-confirm-btn" onClick={onMergeConfirm}>
                Sync to Cloud
              </button>
              <button className="sync-cancel-btn" onClick={onDismissSync}>
                Use Cloud Data
              </button>
            </div>
            <p className="sync-note">💡 Cloud data is always your source of truth.</p>
          </div>
        </div>
      )}

      {showAnimalSelection && (
        <AnimalSelector onSelectAnimal={onSelectAnimal} />
      )}

      {showEggSelector && (
        <EggColorSelector
          selectedAnimal={selectedAnimal}
          onConfirmBuddy={onConfirmBuddy}
          onBack={onBackToAnimalSelection}
        />
      )}
    </>
  );
}

export default AuthOverlays;